import React from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CardStatus from '../CardStatus';
import { connect } from 'react-redux';

import { COLORS, commonStyles } from '../../styles/styles';
import avatar from '../../assets/avatar.jpg';
import mail from '../../assets/closeEnvelope.svg';
import Edit from '@material-ui/icons/Edit';
import darkGradient from '../../assets/darkGradient.svg';
import Card from 'react-bootstrap/Card'
import Badge from 'react-bootstrap/Badge'
import { MDBBtn, MDBCard, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText, MDBRow, MDBCol, MDBIcon, MDBBadge, MDBContainer } from
'mdbreact';
import {setProfilePopup, selectUser, selectUserPrograms, selectRollout} from '../../redux/reducers/userProgramsFull'
import { withRouter } from 'react-router-dom';


import {showMessageCenter} from '../../redux/reducers/messagesList'
import { selectedUser } from '../../redux/selectors';
import { STORAGE_LINK } from '../../constants';

const getInProgress = (programs) => {
  var inprogress = 0;
  for (let i = 0; i < programs.programs.length; i++) {
    const element = programs.programs[i];
    if(element.status=='in progress'){
      inprogress++
    }
    
  }
  return inprogress;
}
const getCompleted = (programs) => {
  var completed = 0;
  for (let i = 0; i < programs.programs.length; i++) {
    const element = programs.programs[i];
    if(element.status=='completed'){
      completed++
    }
    
  }
  return completed;
}


const UserCard = ({
  classes,
  isSelected,
  isTransparent,
  backgroundImg,
  type,
  name,
  dueDate,
  startDate,
  description,
  contentId,
  onThinkToolClick,
  status,
  messageCount,
  user,
  setProfilePopup, 
  programs,
  showMessageCenter,
  showPrograms,
  returnFromUserCard
}) => (
  <MDBContainer>
    {}
   {user && <MDBCard className='z-depth-2 d-none d-md-block'>
      

    <div  className="compImg" style={{position:'relative'}}>
          {user && user.avatar ? <img src={STORAGE_LINK+user.avatar} className="z-depth-0  rounded-corners" style={{padding: 10, height: '100%', width: '100%'}} alt="" /> : <img src={avatar} className="z-depth-0 rounded-corners" style={{padding: 10, height: '100%', width: '100%'}} alt="" />}
          <MDBBtn
          floating
          tag='a'
          className='ml-n4  mr-auto'
          size='sm'
          action
          style={{position: 'absolute', left: 8, top:44}} 
        onClick={()=>returnFromUserCard()}
      >
        <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
        </MDBBtn>
      
        </div>
    
        <MDBCardBody >
        <h6 className='text-left'>
            {user && user.firstname+' '+user.lastname}
        </h6>
        {user && user.biography ? <div className='copy text-left pt-3'>
        {user.biography}
          </div> : <div className='copy grey-text'>
            Click the edit button to add your avatar or change your bio.
          </div>}
        {/* {user.biography ? <div className='text-black-50 text-left pt-3'>
        {user.biography}
          </div> : <div className='text-black-50 text-left pt-3'>
            No biography entered
          </div>} */}
        </MDBCardBody>

        <div className='gothamBlack text-left small-copy pt-1 pb-2 pl-4 special-color-light' style={{borderTop: '1px solid #ddd', borderBottom: '1px solid #ddd', fontSize:'0.7rem', marginBottom:10}}>
          <div style={{marginTop:6}} className={classes.mailBadge} onClick={()=>showMessageCenter(true)}>
            <MDBIcon style={{fontSize:'1.5em'}} far icon="envelope" className="green-text" size="lg" />
            {(user && user.numberOfUnreadMessages!=0) ?
            <MDBBadge className="badge-pill-round"  color="danger-color">{user.unreadMsgs}</MDBBadge>
            : null
            }
          </div>                  
          MESSAGES({user.unreadMsgs})
        </div>
        
        {/* <div className='grey-text text-left small-copy pt-1 pb-2 pl-4 special-color-light' style={{borderTop: '1px solid #ddd'}}>
          <div className={classes.mailBadge} onClick={()=>showMessageCenter(true)}>
            <MDBIcon style={{fontSize:'2em'}} far icon="envelope" className="green-text" size="lg" />
            <MDBBadge className="badge-pill-round"  color="danger-color">{user.unreadMsgs}</MDBBadge>
          </div>                  
          MESSAGES({user.unreadMsgs})
        </div> */}
</MDBCard> }
      {/* <div className="pl-10 pr-10">
        <div style={{borderBottom:'solid 1px #D8D8D8', paddingBottom:30}}>
          <div  style={{width:'50%', float:'left', paddingLeft: 5}}>
            <div className='md-copy-bold grey-text text-left pt-3'>
              IN PROGRESS
            </div>
            <div className='ratings-copy text-left pt-3'>
              {programs && getInProgress(programs)}
            </div>
          </div>
          <div  style={{width:'50%', float:'right', paddingRight: 5}}>
          <div className='md-copy-bold grey-text text-left pt-3 pl-1'>
            COMPLETED
          </div>
          <div className='ratings-copy text-left pt-3'>
          {programs && getCompleted(programs)}
          </div>
          </div>
          <div style={{clear:'both'}}></div>
        </div>
      </div> */}
  </MDBContainer>
);

UserCard.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  isTransparent: PropTypes.bool,
  backgroundImg: PropTypes.string,
  type: PropTypes.string,
  messageCount: PropTypes.number,
  name: PropTypes.string,
  dueDate: PropTypes.string,
  startDate: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  contentId: PropTypes.number,
  onThinkToolClick: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
  card: {
    borderRadius: '0 !important',
    justifyContent: 'space-between',
    width: 200,
    height: 280,
    backgroundSize: 'cover',
    margin: 5,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    backgroundColor: COLORS.white,
    opacity: 1,
  },
  isTransparent: {
    opacity: 0.4,
  },
  selectedCard: {
    borderColor: COLORS.cornerstoneRed,
  },
  cardContent: {
    padding: 0,
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  cardContentWrapper: {
    padding: 20,
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
  },
  fileWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '15px 15px 30px 15px',
    backgroundColor: '#161616',
    flex: 1,
    backgroundSize: '100%'
  },
  cardIcon:{
    position: 'absolute',
    bottom: 15,
    right: 15,
    height: 50
  },
  fullWidth:{
    width:'100%',
    margin:'0 0 5px 0',
  },
  cardTitle: {
    fontFamily: 'Gotham-Black',
    color: COLORS.darkGrey,
    fontSize: 16,
    lineHeight: '20px',
    marginBottom: 10,
  },
  itemLeft: {
    flex: 4,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    marginTop: 28,
    '&:focus': {
      outline: 'none',
    },
  },
  moduleDescription: {
    color: COLORS.darkGrey,
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  doneWrapper: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  userIcon:{
    top: 30,
    position: 'absolute',
    left: 5
  },
  mailBadge:{
    position: 'relative',    
    marginTop: 12,
    display: 'inline-block',
    marginRight: 15
  }
});


const mapStateToProps = state => ({
  user: selectedUser(state),
  programs: state.userProgramsFullReducer
});

const mapDispatchToProps = dispatch => ({
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  setProfilePopup: (bool) => dispatch(setProfilePopup(bool)),
  showMessageCenter: bool => dispatch(showMessageCenter(bool)),
  selectUserPrograms:(int) => dispatch(selectUserPrograms(int)),
  selectRollout:(int) => dispatch(selectRollout(int)),
  resetUserPrograms: () => dispatch(resetUserPrograms()),
  selectUser:(int) => dispatch(selectUser(int)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    returnFromUserCard: props => () => {
  
      props.history.push(
        `/users/${props.programs.selectedProjectId}/${props.programs.selectedRollout}`+ props.history.location.search,
      );
    }
  }),
  lifecycle({
    componentWillMount(){
      console.log('CAll me user card', this.props.match.params)
      if(this.props.match.params.projectId){
        this.props.selectUserPrograms(parseInt(this.props.match.params.projectId))
      }
      if(this.props.match.params.rolloutId){
        
        this.props.selectRollout(parseInt(this.props.match.params.rolloutId))
      }
      if(this.props.match.params.userId){
        
        this.props.selectUser(parseInt(this.props.match.params.userId))
      }
    }
  }),
  withStyles(styles),
)(UserCard);



// WEBPACK FOOTER //
// ./src/Components/Cards/UserCard.jsx